import Transformer from './transformer';
import userTransformer from './user';

export default class ProviderReviewTransformer extends Transformer {
  static fetch(data) {
    const newCollection = [];

    if (data.length === 0) {
      return newCollection;
    }

    data.forEach((data) => {
      newCollection.push({
        id: data.id,
        comment: data.comment,
        status: data.status,
        anonymous: data.anonymous,
        created_at: data.created_at,
        updated_at: data.updated_at,
        deleted_at: data.deleted_at,
        appointment_id: data.appointment_id,
        user: data.user ? this.fetchUser(data.user) : {},
        provider: data.provider ? this.fetchProvider(data.provider) : {},
        keyword: data.keyword ? this.fetchKeyword(data.keyword) : [],
        patient_name: data.patient_name,
        report_number: data.report_number,
        review_rating: data.review_rating ? this.fetchRating(data.review_rating) : {},
        display_name: data.display_name,
      });
    });

    return newCollection;
  }

  static isObject(data) {
    return typeof data === 'object';
  }

  static fetchProvider(provider) {
    return {
      id: provider.id,
      user_id: provider.user_id,
      prefix_en: this.isObject(provider.prefix) ? provider.prefix.en : this.getLangName(provider.prefix, 'en'),
      prefix_th: this.isObject(provider.prefix) ? provider.prefix.th : this.getLangName(provider.prefix, 'th'),
      firstname_en: this.isObject(provider.firstname)
        ? provider.firstname.en
        : this.getLangName(provider.firstname, 'en'),
      firstname_th: this.isObject(provider.firstname)
        ? provider.firstname.th
        : this.getLangName(provider.firstname, 'th'),
      lastname_en: this.isObject(provider.lastname) ? provider.lastname.en : this.getLangName(provider.lastname, 'en'),
      lastname_th: this.isObject(provider.lastname) ? provider.lastname.th : this.getLangName(provider.lastname, 'th'),
      slug: provider.slug,
      description_en: this.isObject(provider.description)
        ? provider.description.en
        : this.getLangName(provider.description, 'en'),
      description_th: this.isObject(provider.description)
        ? provider.description.th
        : this.getLangName(provider.description, 'th'),
      citizenid: provider.citizenid,
      passport: provider.passport,
      gender: provider.gender,
      language_en: this.isObject(provider.language) ? provider.language.en : this.getLangName(provider.language, 'en'),
      language_th: this.isObject(provider.language) ? provider.language.th : this.getLangName(provider.language, 'th'),
      type: provider.type,
      hidden: provider.hidden,
      visibility: provider.visibility || [],
      allow_donation: provider.allow_donation,
      license_number: provider.license_number,
      expertise_en: this.isObject(provider.expertise)
        ? provider.expertise.en
        : this.getLangName(provider.expertise, 'en'),
      expertise_th: this.isObject(provider.expertise)
        ? provider.expertise.th
        : this.getLangName(provider.expertise, 'th'),
      workplace: provider.workplace,
      education: provider.education || [],
      certificate: provider.certificate,
      approved: provider.approved,
      archived: provider.archived,
      avatar: provider.avatar,
      address: provider.address,
      announcement: provider.announcement,
      current_performance: provider.current_performance,
      bank_account: provider.bank_account,
      bank_brand: provider.bank_brand,
      bank_branch: provider.bank_branch,
      session_count: provider.session_count,
      attachments: provider.attachments || [],
      created_at: provider.created_at,
      updated_at: provider.updated_at,
      topics: provider.topics || [],
      tags: provider.tags || [],
      user: provider.user ? userTransformer.fetch(provider.user) : {},
      total_unpaid: provider.total_unpaid,
      tax_unpaid: provider.tax_unpaid,
      total_unpaid_with_tax: provider.total_unpaid_with_tax,
      provider_types: provider.provider_types,
      // provider_sub_types: provider.provider_sub_types,
    };
  }

  static fetchRating(rating) {
    return {
      rating: rating.rating,
      title: rating.title,
    };
  }

  static fetchUser(user) {
    return {
      id: user.id,
      email: user.email,
      tel: user.tel,
      email_verification_token: user.email_verification_token,
      email_verification_created: user.email_verification_created,
      email_confirmed: user.email_confirmed,
      tel_verification_token: user.tel_verification_token,
      tel_verification_created: user.tel_verification_created,
      otp_ref: user.otp_ref,
      tel_confirmed: user.tel_confirmed,
      email_new: user.email_new,
      tel_new: user.tel_new,
      wallet: user.wallet,
      setting: user.setting,
      timezone: user.timezone,
      language: user.language,
      device_tokens: user.device_tokens,
      forgot_pass_token: user.forgot_pass_token,
      auth_token: user.auth_token,
      support_pin: user.support_pin,
      created_at: user.created_at,
      updated_at: user.updated_at,
    };
  }

  static fetchKeyword(keyword) {
    const keywordList = keyword.map((data) => {
      return {
        keyword_en: data.en,
        keyword_th: data.th,
      };
    });

    return keywordList;
  }

  static fecthReport(report) {
    return report.map((data) => ({
      id: data.id,
      review_id: data.review_id,
      user: data.user ? this.fetchUser(data.user) : {},
      removal_reason: data.removal_reason,
      created_at: data.created_at,
    }));
  }

  static getLangName(name, lang) {
    if (name) {
      const nameObject = JSON.parse(name);
      return lang === 'en' ? nameObject.en : nameObject.th;
    }

    return '';
  }
}
